// =====================================================
// Scroll To Top Button
// =====================================================

import gsap from "gsap";

export function initScrollToTop() {
    // Get existing button from HTML (in footer.php)
    const button = document.querySelector(".scroll-to-top");
    if (!button) return;

    // Set initial state (hidden)
    gsap.set(button, {
        opacity: 0,
        scale: 0.8,
        pointerEvents: "none",
    });

    let isVisible = false;

    // Show/hide based on scroll position
    function checkScroll() {
        const scrollY = window.scrollY || window.pageYOffset;

        if (scrollY > 700 && !isVisible) {
            isVisible = true;
            gsap.to(button, {
                opacity: 1,
                scale: 1,
                pointerEvents: "auto",
                duration: 0.3,
                ease: "power2.out",
            });
        } else if (scrollY <= 250 && isVisible) {
            isVisible = false;
            gsap.to(button, {
                opacity: 0,
                scale: 0.8,
                pointerEvents: "none",
                duration: 0.3,
                ease: "power2.out",
            });
        }
    }

    // Listen to scroll events
    window.addEventListener("scroll", checkScroll, { passive: true });

    // Check initial state
    checkScroll();

    // Click handler - smooth scroll to top
    button.addEventListener("click", () => {
        window.dispatchEvent(new CustomEvent("scrollToTop"));
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}
